import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useAddNewTaskBaseMutation } from "./taskBasesApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faSave } from "@fortawesome/free-solid-svg-icons"
import TimeLeft from '../../partial/TimeLeft'
import Uploader from "../../partial/Uploader"
import ReactQuill from 'react-quill';
import GradeStepsMain from "../grade-steps/GradeStepsMain"


const NewTaskBaseForm = ({ courses }) => {
    const {groupId, type} = useParams()
    const [addNewTaskBase, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewTaskBaseMutation()

    const navigate = useNavigate()

    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')
    const [course, setCourse] = useState('')
    const [active, setActive] = useState(true)
    const [incluedInGrade, setIncluedInGrade] = useState(true)
    const [defaultCheckInclueRelatedFriends, setDefaultCheckInclueRelatedFriends] = useState(true)

    const [order, setOrder] = useState(0)

    const [ratio, setRatio] = useState(0)
    const [img, setImg] = useState('')
    const [gradeSteps, setGradeSteps] = useState([])

    useEffect(() => {
        if (isSuccess) {
            setTitle('')
            setBody('')
            setCourse('')
            setOrder(0)
            setRatio(0)
            setActive(true)
        }
    }, [isSuccess, groupId, navigate])

   
    const canSave = [title, body, course].every(Boolean) && !isLoading

    const onSaveTaskBaseClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
             const savedGradesSteps = gradeSteps.map(step => {
                return {
                    ...step,
                    _id: step._id.length > 15? step._id : undefined
                }
            })  
         const {data} =    await addNewTaskBase({ course, title, body, active,   order, img, ratio, incluedInGrade, defaultCheckInclueRelatedFriends,  gradeSteps : savedGradesSteps})
         if(data?.id)
            navigate(`/${type}/${groupId}/task-bases/${data?.id}`)
        }
    }

    const options = courses.map(course => {
        return (
            <option
                key={course.id}
                value={course.id}
            > {course.name}</option >
        )
    })

    const errClass = isError ? "errmsg" : "offscreen"

    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveTaskBaseClicked}>
                <div className="form__title-row">
                    <h2>New TaskBase</h2>
                    <div className="form__action-buttons">
                    <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/task-bases`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="title">
                    Title:</label>
                <input
                    className={`form__input  ${!title &&'form__input--incomplete'}`}
                    id="title"
                    maxLength={20}
                    name="title"
                    type="text"
                    autoComplete="off"
                    value={title}
                    onChange={(e)=>setTitle(e.target.value)}
                />
               

                <label className="form__label" htmlFor="body">
                    Body:</label>

                    <ReactQuill                   
                    value={body}
                    onChange={setBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          //[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{size: []}],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />    
                {/* <textarea
                    className={`form__input form__input--text ${!body &&'form__input--incomplete'}`}
                    id="body"
                    name="body"
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                /> */}
                 <Uploader label={'Img'} folderId={'MANAGE_TASKS'} file={img} setFile={setImg} isImg={true} />

                
            
                <div className="form-flex">
                <div className="form-input-container">


                    <label className="form__label form__checkbox-container" htmlFor="course">
                        COURSE:</label>
                    <select
                        id="course"
                        name="course"
                        className={`form__input  ${!course &&'form__input--incomplete'}`}
                        value={course}
                        onChange={(e)=>setCourse(e.target.value)}
                    >
                        <option></option>
                        {options}
                    </select>
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-order">
                    Order:</label>
                <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>
                <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>

     
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-include-in-grade">
                    Inclued In Grade:
                    <input
                        className="form__checkbox"
                        id="user-include-in-grade"
                        name="user-include-in-grade"
                        type="checkbox"
                        checked={incluedInGrade}
                        onChange={(e)=>setIncluedInGrade(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
                <div className="form-input-container">
                    <div className="form__divider">
                    <label className="form__label form__checkbox-container" htmlFor="user-relatedFriend">
                    סימון ציון גם לחברות בברירת מחדל
                    <input
                        className="form__checkbox"
                        id="user-relatedFriend"
                        name="user-relatedFriend"
                        type="checkbox"
                        checked={defaultCheckInclueRelatedFriends}
                        onChange={(e)=>setDefaultCheckInclueRelatedFriends(prev => !prev)}
                    />
                </label>
               
                    </div>
                
                </div>
        <div className="form-input-container">
                    <GradeStepsMain gradeSteps={gradeSteps} setGradeSteps={setGradeSteps} />
                </div>

                <label className="form__label form__checkbox-container" htmlFor="user-active">
                    ACTIVE:
                    <input
                        className="form__checkbox"
                        id="user-active"
                        name="user-active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                </label>

            </form>
        </>
    )

    return content
}

export default NewTaskBaseForm